
  import { defineComponent, onMounted, reactive } from "vue";
  import { common } from "@/common/services/Common";
  import { ethitransService } from "@/services/EthitransService";
  
  export default defineComponent({
    name: "AdminDetailsModal",
    props : {
        showModal : Boolean,
        selected : Object,
        uuid: String,
    },
    setup(props, {emit}) {
      // const router = useRouter();
      const state = reactive({
            status: '' as any,
            filterStatus: '' as any,
            fields: {

            } as any,
            // projectId: projectId,
            // uuid: uuid,
            hasShownDetails: false,
            selectUnitId: '' as any,
            selectJobEstimationItemIndex: '' as any,
            selectItemIndex: '' as any,
            selectJobEstimationItem: '' as any,
            data: {
                subscriptionDetails: {
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    appointment_numbers: 0,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    archive_channel: 0,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    channel_file_size: 0,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    channel_message_history: 0,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    channel_per_project: 0,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    estimation_per_project: 0,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    export_channel_pdf: 0,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    files_number: 0,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    folder_number: 0,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    guests_per_project: 0,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    import_option: 0,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    invoice_payment: 0,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    member_in_smart_contract: 0,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    member_per_channel: 0,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    members_per_appointment: 0,
                    name: "Silver",
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    pdf_number: 0,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    phase_per_smart_contract: 0,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    private_channel: 0,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    project_number: 0,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    sync_option: 0,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    task_per_phase: 0,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    template_number: 0,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    total_channel_member: 0,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    total_estimation: 0,
                } as any,
                role: '' as any,
                channel: '' as any,
                title: "data found",
                headings: "Job Estimation",
                note: '' as any,
                jobEstimationLists: [] as any,
                unitLists: [] as any,
                details: {} as any,
                unit: {
                    name: '',
                    abbreviation: '',
                },
                companyInfo: {
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    company_name: "",
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    company_email: "",
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    company_phone_number: "",
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    company_address: "",
                    acknowledgement: "",
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    legal_statement: "",
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    logo: "",
                },
            },
            ui: {
                isActive: {
                    upgradeSubscription: false,
                },
                isLoading: {
                    packageDetailsByUser: false,
                    isEdit: false,
                    geJobEstimationList: false,
                    isUnitEdit: false,
                    getUnit: false,
                    pusherUpdate: false,
                },
                isPostLoading: {
                    delete: false,
                    addUnite: false,
                },
                errors: {
                    errorList: [] as any,
                    validationErrorList: {
                        itemName: "",
                        unitName: "",
                    },
                    hasError: false,
                },
            },
        });
      function closeDetailModal() {
        emit("close");
        $("#detailModal").modal("hide");
      }
      function selectFile(item: object) {
        emit("selectedFile", item);
      }
    //   function showShareModal(file: any) {
    //     closeDetailModal();
    //     console.log("selected>>", file);
    //     selectFile(file);
    //     file.isChecked = true;
    //     state.data.selectedFolder = file;
    //     state.data.showShareModal = !state.data.showShareModal;
    //   }
    //   function downloadFile(data: any) {
    //     state.ui.error.errorList.downloadFile = [];
    //     state.ui.error.hasError = false;
    //     if (
    //       state.ui.error.errorList.renameSelectedFolder.length != 0 ||
    //       state.ui.error.hasError ||
    //       state.ui.isPostLoading.downloadFile
    //     )
    //       return false;
    //     const payLoad = {
    //       // eslint-disable-next-line @typescript-eslint/camelcase
    //       file_id: data.uuid,
    //     };
    //     state.ui.isPostLoading.downloadFile = true;
    //     ethitransService
    //       .fileDownload(payLoad)
    //       .then((res: any) => {
    //         console.log("Project List Response Check:>>> ", res.data.data);
    //         window.open(res.data.data, "_blank");
    //         // closeRenameModal()
    //         // resetTheName(res.data.data)
    //       })
    //       .catch((error: any) => {
    //         // console.log(error);
    //         common
    //           .sdCatchErr(error, state.ui.error.errorList.downloadFile)
    //           .then((res: any) => {
    //             state.ui.error.hasError = true;
    //             for (const [key, value] of Object.entries(res)) {
    //               if (Array.isArray(value)) {
    //                 state.ui.error.errorList.downloadFile.push(value[0]);
    //               }
    //             }
    //           });
    //       })
    //       .finally(() => {
    //         state.ui.isPostLoading.downloadFile = false;
    //       });
    //   }

    function downoadPdf(url: any) {
      window.open(url, '_blank');
     }
    function geJobEstimationDetails(uuid: any) {
            state.data.details = {};
            state.ui.isLoading.geJobEstimationList = true
            ethitransService
                .geJobEstimationDetailsPreview(uuid)
                .then((res: any) => {
                    state.fields = res.data.data.fields;
                    res.data.data.total = 0;
                    state.data.note = res.data.data.note;
                    state.data.channel = res.data.data.channel.name;
                    res.data.data.singed_customers.forEach((customer: any) => {
                        // eslint-disable-next-line @typescript-eslint/camelcase  
                        customer.signaute_date = common.localDateOnly(customer.signaute_date);
                    })
                    // eslint-disable-next-line @typescript-eslint/camelcase  
                    res.data.data.signature_date = common.localDateOnly(res.data.data.signature_date ? res.data.data.signature_date : '');
                    res.data.data.phases.forEach((item: any) => {
                        item.sub_items.forEach((subItem: any) => {
                            subItem.selectUnit = state.data.unitLists.filter((unit: any) => unit.id === subItem.unit_id)[0];
                            if (subItem.markup_type == 1) {
                                const parCal = ((parseFloat(subItem.cost) * parseFloat(subItem.quantity)) * parseFloat(subItem.markup)) / 100;
                                subItem.total = parCal + (parseFloat(subItem.cost) * parseFloat(subItem.quantity));
                                res.data.data.total += subItem.total;
                                subItem.total = common.usdPriceFormate(subItem.total);
                                subItem.markup = common.takeLimitDigits(subItem.markup ? subItem.markup : 0);
                            } else {
                                subItem.total = (parseFloat(subItem.cost) * parseFloat(subItem.quantity)) + parseFloat(subItem.markup);
                                res.data.data.total += subItem.total;
                                subItem.total = common.usdPriceFormate(subItem.total);
                                subItem.markup = common.usdPriceFormate(subItem.markup ? subItem.markup : 0);
                            }
                            subItem.subTotal = (parseFloat(subItem.cost) * parseFloat(subItem.quantity));
                            subItem.subTotal = common.usdPriceFormate(subItem.subTotal);
                            subItem.cost = common.usdPriceFormate(subItem.cost);
                            subItem.allowance = subItem.allowance ? common.usdPriceFormate(subItem.allowance) : '-';
                        });
                    });
                    res.data.data.total = common.usdPriceFormate(res.data.data.total);
                    res.data.data.modifiedCreatedDate = common.formatDateAndTime(res.data.data.created_at);
                    state.data.details = res.data.data;


                })
                .catch((error: any) => {
                    console.log(error);
                })
                .finally(() => {
                    state.ui.isLoading.geJobEstimationList = false;
                });
        }

        function detailsCloseAdmin() {
            emit("close")
            $("#showDetailsAdmin").modal("hide");
        }
        
      onMounted(() => {
          if(props.showModal){
            geJobEstimationDetails(props.uuid);
            $("#showDetailsAdmin").modal("show");
          }
        //   getFolderList();
      });
  
      return {
        state,
        closeDetailModal,
        selectFile,
        downoadPdf,
        detailsCloseAdmin
        // showShareModal,
        // downloadFile,
  
      };
    },
  });
  